module.exports = __webpack_public_path__ + "static/media/xi-hu-lake.62585e66.jpeg";